<template>
  <v-container class="max-width-1200">

    <v-row class="text-justify justify-center">

      <v-col cols="12" sm="8">

        <v-row class="justify-center">
          <v-col>
            <v-row>
              <v-col class="pb-0 headline text-uppercase">
                {{ $t('submetering.contactNow.title') }}
              </v-col>
            </v-row>
            <v-row>
              <v-col class="display-1">
                {{ $t('submetering.contactNow.subtitle')}}!
              </v-col>
            </v-row>

            <v-row>
              <v-col>
                {{ $t('common.mobile') }}:
                <span id="showPhoneNumberSpan" v-if="!showPhoneNumberContactNow" class="mouse-hover-link fontcolor-primary mr-4" @click="toggleShowPhoneNumberContactNow()">{{ $t("common.showPhoneNumber") }}</span>
                <span id="phoneNumberSpan" v-if="showPhoneNumberContactNow" class="mouse-hover-link fontcolor-primary mr-4" @click="openPhone('+36303887258')">+36 30 388 7258</span> <br>
                {{ $t('common.email') }}:
                <span id="showEmailSpan" v-if="!showEmailContactNow" class="mouse-hover-link fontcolor-primary" @click="toggleShowEmailContactNow()">{{ $t("common.showEmail") }}</span>
                <span id="emailSpan" v-if="showEmailContactNow" class="mouse-hover-link fontcolor-primary" @click="openMail('info@rubin.hu')">info@rubin.hu</span>
              </v-col>
            </v-row>

          </v-col>
        </v-row>

      </v-col>

      <v-col cols="12" sm="4">
        <v-img
          src="@/assets/img/img-contact-01.jpg"
          contain
          class="mr-auto">
        </v-img>
      </v-col>


    </v-row>

  </v-container>
</template>

<script>
  import DataComponentBase from '@/commons/DataComponentBase';

  export default {
    name: 'SubMeteringCost',
    extends: DataComponentBase,

    data: () => ({
    }),

    computed: {
    },
    methods: {
      openQuestioner() {
        let url = "https://docs.google.com/forms/d/e/1FAIpQLSd1sy6EwYUExCqsEhhuCpBh25hXLL-YQxC7riSs9bbXc_Sbkg/viewform?embedded=true";
        window.open(url,'_blank');
      },
    },
  }
</script>
